import { motion } from "framer-motion";
import { Reveal } from "../landing/Reveal";

const SKILLS = [
  { name: "AI Skills", pct: 80, color: "from-[#7C3AED] to-[#A78BFA]" },
  { name: "Public Speaking", pct: 55, color: "from-[#06B6D4] to-[#4ADE80]" },
  { name: "Design Basics", pct: 35, color: "from-[#22C55E] to-[#F97316]" },
];

const BADGES = ["🔥 21-day streak", "🏆 Quiz Master", "⚡ Speed Learner", "🎯 Perfect Week"];

const BOARD = [
  { name: "Anjali", xp: "12,480 XP" },
  { name: "You", xp: "11,905 XP", you: true },
  { name: "Rahul", xp: "11,540 XP" },
];

export const LearnBite = () => (
  <section id="learnbite" data-testid="learnbite-section" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute -right-32 top-1/4 h-[380px] w-[380px] rounded-full bg-[#7C3AED]/15 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
        <Reveal delay={0.12} className="order-2 lg:order-1">
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl sm:p-8" data-testid="learnbite-panel">
            <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-400">
              Skill Progress
            </p>
            <div className="mt-5 space-y-5">
              {SKILLS.map((s) => (
                <div key={s.name}>
                  <div className="mb-2 flex justify-between text-sm">
                    <span className="font-semibold text-slate-200">{s.name}</span>
                    <span className="font-jbmono text-xs text-[#06B6D4]">{s.pct}%</span>
                  </div>
                  <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/5">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${s.pct}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                      className={`h-full rounded-full bg-gradient-to-r ${s.color}`}
                    />
                  </div>
                </div>
              ))}
            </div>
            <button data-testid="learnbite-continue" className="glow-btn-b mt-7 w-full rounded-full bg-gradient-to-r from-[#7C3AED] to-[#06B6D4] py-3.5 font-display text-xs font-bold uppercase tracking-wider text-white">
              Continue Learning
            </button>
            <div className="mt-6 flex flex-wrap gap-2">
              {BADGES.map((b) => (
                <span key={b} className="rounded-full border border-[#22C55E]/25 bg-[#22C55E]/10 px-3 py-1.5 text-[11px] font-semibold text-[#22C55E]">
                  {b}
                </span>
              ))}
            </div>
            <div className="mt-6 rounded-2xl border border-white/5 bg-[#09090B]/80 p-4">
              <p className="mb-3 font-jbmono text-[10px] uppercase tracking-widest text-slate-500">
                Weekly Leaderboard
              </p>
              {BOARD.map((u, i) => (
                <div key={u.name} className={`flex items-center justify-between rounded-xl px-3 py-2 text-sm ${u.you ? "bg-[#7C3AED]/15 text-white" : "text-slate-400"}`}>
                  <span>#{i + 1} {u.name}</span>
                  <span className="font-jbmono text-xs text-[#06B6D4]">{u.xp}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal className="order-1 lg:order-2">
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#7C3AED]">📚 LearnBite</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Learning that hits like a game.
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-slate-400">
            Duolingo energy for real skills: streaks, XP, badges and leaderboards —
            with certifications recruiters actually respect.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
